import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { ControllerType, HttpClientService } from '../http-client.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentMovementService {
  constructor(private httpClientService: HttpClientService) { }

  async getAllAssignments(page: number, size: number, search: string, equipmentId?: number, movementType?: number, firstDate?: string, secondDate?: string, fromPersonId?: number, toPersonId?: number, isHistory?: boolean, projectId?: number,isLastMovement?:boolean) {
    let params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('size', size.toString());
    params.set('search', search);

    if (equipmentId !== null && equipmentId !== undefined) {
      params.set('EquipmentKindId', equipmentId.toString());
    }
    if (toPersonId !== null && toPersonId !== undefined) {
      params.set('toPersonId', toPersonId.toString());
    }
    if (fromPersonId !== null && fromPersonId !== undefined) {
      params.set('fromPersonId', fromPersonId.toString());
    }
    if (movementType !== null && movementType !== undefined) {
      params.set('movementType', movementType.toString());
    }
    if (firstDate) {
      params.set('firstDate', firstDate);
    }
    if (secondDate) {
      params.set('secondDate', secondDate);
    }
    if (isHistory) {
      params.set('isHistory', isHistory.toString());
    }
    if (isLastMovement !== null) {
      params.set('isLastMovement', isLastMovement.toString());
    }
    if (projectId !== null && projectId !== undefined) {
      params.set('projectId', projectId.toString());
    }
    
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AssignmentMovement,
      queryString: params.toString()
    });
    return await firstValueFrom(observable);
  }

  async getByIdAssignment(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AssignmentMovement
    }, id);
    return await firstValueFrom(observable);
  }

  async getAssignmentMovement(page: number, size: number, id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AssignmentMovement,
      action: 'GetAssignmentMovement',
      queryString: `page=${page}&size=${size}&id=${id}`
    });
    return await firstValueFrom(observable);
  }

  async createAssignmentMovement(data: any) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.AssignmentMovement
    }, data);
    return await firstValueFrom(observable);
  }

  async updateAssignmentMovement(data: any) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.AssignmentMovement
    }, data);
    return await firstValueFrom(observable);
  }

  async deleteAssignmentMovement(id: number) {
    const observable: Observable<any> = this.httpClientService.delete({
      controller: ControllerType.AssignmentMovement,
      action: `${id}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdPersonAssignmentMovements(page, size, personId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AssignmentMovement,
      queryString: `Page=${page}&size=${size}&personId=${personId}`,
      action: "GetByIdPersonAssignmentMovements"
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
